export const VIDEO_FORMAT = ['mp4', 'avi', 'mov', 'mkv'];

export const getEventMode = {
  online: 'Online',
  offline: 'Offline',
};
export const Status_Option = {
  1: 'completed',
  2: 'ongoing',
  3: 'upcoming',
};
export const Approval_Status_Option = {
  1: 'Approved',
  2: 'Rejected',
  3: 'Pending',
};

export const MemberPortal_Status_Option = {
  1: 'Invite sent',
  2: 'Signed',
  3: 'Not Sent',
};

export const Status_Code = {
  1: '#006B67',
  2: '#ED7700',
  3: '#4285F4',
  // "completed": "#24A147",
  // "ongoing": "#2066DF",
  // "upcoming": "#FF832C",
  // "postponed": "#480C1C",
  // "cancelled": "#DA1E28",
  // completed: '#006B67',
  // ongoing: '#ED7700',
  // upcoming: '#4285F4',
  // postponed: '#480C1C',
  // cancelled: '#DA1E28',
  completed: '#11BB30',
  ongoing: '#288DC0',
  upcoming: '#ED7700',
  postponed: '#213F7C',
  cancelled: '#64686B',
  yet_to_start: '#4285F4',
  not_verified: '#ED7700',
  verified: '#34A853',
  in_progress: '#006ADA',
  invite_sent: '#ED7700',
  in_event_training: '#4285F4',
  approved_to_attend: '#34A853',
  rejected_to_attend: '#B41E45',
  registered: '#006B67',
  in_event_survey: '#006ADA',
  //Tv farmer
  approved: '#006B67',
  rejected: '#D0382A',
  pending: '#FBBC05',
  //CC
  Invite_sent: '#006ADA',
  Signed: '#34A853',
  Not_Sent: '#ED7700',
  Eligible: '#34A853',
  draft: '#FF8D29',
  submitted: '#006B67',
  Verified: '#34A853',
  yet_to_verified: '#ED7700',
};

export const Score_Code = {
  1: '#B41E45',
  2: '#B41E45',
  3: '#FBC013',
  4: '#34A853',
  5: '#34A853',
};
export const Farmer_Status_Color = {
  Rejected: '#B41E45',
  Approved: '#34A853',
  Profile_Submitted: '#4E4F54',
};

export const Training_Status_Color = {
  training_rejected: '#B41E45',
  training_approved: '#34A853',
  in_event_training: '#FBBC05',
};
export const DocumentStatus_Code = {
  completed: '#10b981',
  partially_completed: '#FBBC05',
  not_completed: '#ef4444',
  pending: '#FBBC05',
};
export const Farmer_Status_Name = {
  Rejected: 'Rejected',
  Approved: 'Approved',
  Profile_Submitted: 'Profile Submitted',
};
export const Approval_Status_Name = {
  Rejected: 'Rejected',
  Approved: 'Approved',
  Pending: 'Pending',
  Cancelled: 'Cancelled',
};
export const Training_Status_Name = {
  // "training_rejected": "Rejected",
  // "Attendance_Marked": "Approved",
  // "approved_to_attend": "Approved",
  // "event_completed": "Completed",
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
};
export const DFTraining_Status_Name = {
  // "training_rejected": "Rejected",
  // "Attendance_Marked": "Approved",
  // "approved_to_attend": "Approved",
  // "event_completed": "Completed",
  in_event_training: 'Pending',
  training_approved: 'Approved',
  training_rejected: 'Rejected',
};

export const Audit_In_ReviewStatus_Name = {
  // "training_rejected": "Rejected",
  // "Attendance_Marked": "Approved",
  // "approved_to_attend": "Approved",
  // "event_completed": "Completed",
  Audit_In_Review_Approved: 'Accepted',
  Audit_In_Review_Rejected: 'Rejected',
  Audit_In_Review: 'Pending',
};

export const Potential_Status_Name = {
  in_progress: 'Partially Verified',
  not_verified: 'Yet To Verify',
  verified: 'Verified',
  rejected: 'Rejected',
};

export const DIFFUSION = 'diffusion';
export const RESEARCH = 'research';
export const TV = 'traceability_and_verification';
export const SUPER_ADMIN = 'SuperAdmin';
export const PILLAR_HEAD = 'pillar_head';
export const FIELD_OFFICER = 'field_officer';
export const CC = 'certification_and_compliance';
export const LIVELIHOOD = 'livelihood_improvement';

export const ALL_EVENTS = 'all';
export const UPCOMING_EVENTS = 'upcoming';
export const COMPLETED_EVENTS = 'completed';
export const CANCELLED_EVENTS = 'cancelled';
export const ONGOING_EVENTS = 'ongoing';
export const POSTPONED_EVENTS = 'postponed';
export const PREPONED_EVENTS = 'preponed';

export const registered = 'registered';
export const onboarding = 'onboarding';
export const training_approved = 'training';
export const INVITE_SENT = 'INVITE_SENT';
export const REGISTERED = 'REGISTERED';

export const AWAITING_TO_TRACE = 'Awaiting to_Trace';
export const TRACE_TO_PLANTATION = 'Trace to Plantation';
export const TRACE_TO_VERIFY = 'Trace to Verify';

export const FARMER_DETAILS = 'farmer_details';
export const FARM_DETAILS = 'farm_details';
export const WORKER_DETAILS = 'worker_details';
export const FFB_DETAILS = 'ffb_details';

export const TRAINING_LESSON = 'Training_Lesson';
export const COMMENT_FEEDBACK = 'Comments_Feedback';

export const FARMER_REPORT = 'Farmer_Report';
export const SCORECARD_REPORT = 'Scorecard_Report';

export const FARM_REPORT = 'Farm_Report';
export const TTP_DATA_REPORT = 'TTP_data_Report';
export const DOCUMENTS_REPORT = 'Documents';
export const REPORT_SCORECARD = 'Scorecard';
export const APPROVAL_REPORT = 'Approval';

export const VERIFY_FARMER = 'Ferify_farmer';

export const REGISTRATION = 'Registration';
export const TRAINING_COMPLETION = 'Training_Completion';
export const AUDIT_REVIEW = 'Audit_Review';
export const AUDIT_COMPLETION = 'Audit_Completion';

export const EVENT_REPORT = 'events';
export const PARTICIPANT_REPORT = 'farmer';
export const TRAINING_REPORT = 'training';
export const SURVEY_REPORT = 'survey';
export const UPLOADED_REPORT = 'uploaded';

export const ORGANISATIONS = 'Organisations';
export const COLLECTION_CENTRES = 'Collection_Centers';
export const FARMERS = 'Farmers';
export const PLANTATION = 'Plantation';

//cc
export const ELIGIBLE = 'Eligible';
export const PARTIALLYELIGIBLE = 'Partially_Eligible';

export const ADD_DOCUMENTS = 'addDocuments';
export const ADD_DATA = 'addData';

export const Farmer_CcReport = 'Farmers';
export const Farm_CcReport = 'Farm';
export const FFB_CcReport = 'FFB';
export const Fertilizer_CcReport = 'Fertilizer';
export const Chemical_CcReport = 'Chemical';
export const Expenses_CcReport = 'Expenses';
export const Worker_CcReport = 'Worker';
export const Training_CcReport = 'Training';
export const Premium_Calculation_CcReport = 'Premium_Calculation';
export const Uploaded_Report_CcReport = 'Uploaded_Report';

export const LOADER_TIMEOUT = 1000;
export const GLOBAL_LOADER_TIMEOUT = 6000;

export const ModuleKey = {
  dashboard: 'dashboard',
  event: 'events',
  survey: 'survey',
  training: 'training',
  farmer: 'farmer_journey',
  approval: 'approval',
  reportAnalyse: 'reports_and_analytics',
  trace: 'trace',
  datacollection: 'data_collection',
  assessment: 'assessment',
  verification: 'verification',
  PotentialISH: 'potential_ish',
  auditreport: 'audit_report',
  mapping: 'mapping',
  program: 'program',
  setting: 'setting',
  diffusionData: 'data_collection',
  tvData: 'data_collection',
  ccData: 'data_collection',
  livelihoodData: 'data_collection',
  diffusionDashboard: 'dashboard',
  tvDashboard: 'dashboard',
  ccDashboard: 'dashboard',
  livelihoodDashboard: 'dashboard',
  li_report: 'li_assessment_report',
  li_assessment_report: 'li_assessment_report',
};

export const permissionKey = {
  view: 'view',
  edit: 'edit',
  delete: 'delete',
  create: 'create',
  approveReject: 'approve_reject',
  add_event: 'add_event',
  edit_event: 'edit_event',
  mark_attendance: 'mark_attendance',
  invite_participants: 'invite_participants',
  add_participants: 'add_participants',
  edit_participants: 'edit_participants',
  delete_participants: 'delete_participants',
  share: 'share',
  edit_event_status: 'edit_event_status',
  change_event_progress: 'change_event_progress',
  delete_event: 'delete_event',
  add_training_module: 'add_training_module',
  edit_training_module: 'edit_training_module',
  delete_training_module: 'delete_training_module',
  add_lesson: 'add_lesson',
  edit_lesson: 'edit_lesson',
  delete_lesson: 'delete_lesson',
  edit_survey: 'edit_survey',
  edit_survey_response: 'edit_survey_response',
  delete_survey: 'delete_survey',
  add_survey: 'add_survey',
  upload_survey_response: 'upload_survey_response',
  add_survey_response: 'add_survey_response',
  send_survey_response: 'send_survey_response',
  approve_or_reject: 'approve_or_reject',
  upload_report: 'upload_report',
  edit_and_save_audit_data: 'edit_and_save_audit_data',
  uploadReport: 'upload_report',
  trace_add_documents: 'add_documents',
  trace_data: 'upload_data_of_ttp',
  trace_approve_reject: 'approve_or_reject',
  trace_update_proof: 'update_proof_of_ownership',
  datacollection_verify_list_data: 'verify_list_by_selection',
  data_collection_add_data: 'add_basic_details_and_monthly_data',
  data_collection_verify_data: 'verify_basic_details_and_monthly_data',
  data_collection_add_documents: 'add_documents',
  add_documents_by_cc_data_set: 'add_documents_by_cc_data_set',
  add_li_quarter_yearly_data: 'add_li_quarter_yearly_data',
  verify_documents_by_cc_data_set: 'verify_documents_by_cc_data_set',
  data_collection_verify_documents: 'verify_documents',
  potential_ish_trace_data: 'trace_data_&_documents_verify',
  potential_ish_trace_upload: 'trace_data_&_documents_upload',
  potential_ish_approve_reject: 'declaration_documents_verify',
  potential_ish_update_proof: 'declaration_documents_upload',
  assessment_add_data: 'add_assessment_data',
  assessment_edit_data: 'edit_assessment_data',
  assessment_riss_group_data_add: 'riss_group_data_add',
  assessment_view_document: 'view_documents',
  trace_awaiting_to_trace_approve: 'awaiting_to_trace_approve_or_reject',
  desktop_verification: 'desktop_verification',
  edit_field: 'edit_field',
  update_settings: 'update_settings',
  verify_audit_review: 'verify_audit_review',
  download: 'download',
  edit_participant_details: 'edit_participant_details',
  delete_participant_details: 'delete_participant_details',
  add_program: 'add_program',
  update_program: 'edit_program',
  fip_report_download: 'fip_report_download',
  update_basic_details_and_monthly_data: 'update_basic_details_and_monthly_data',
  update_documents_by_cc_data_set: 'update_documents_by_cc_data_set',
  viewResearch_DF: 'research_df',
  viewResearch_TV: 'research_tv',
  viewResearch_CC: 'research_cc',
  viewResearch_LI: 'research_li',
  li_apporval_CI: 'li_approval_CI',
  li_event_registration: 'li_event_registration',
  li_Training_approval: 'li_training_approval',
  li_Program_Core: 'li_program_core',
  li_Program_Primary: 'li_program_primary',
  li_Program_Check: 'li_program_check',
  li_Program_LFD: 'li_program_LFD',
  li_Program_Fertilizer: 'li_program_fertilizer',
};

export const pillarNames = {
  Diffusion: 'DF',
  'Traceability & Verification': 'TV',
  'Certification & Compliance': 'CC',
  'Livelihood Improvement': 'LI',
  Common: 'CM',
};

export const pillarMap = {
  df: { code: 'DF', name: 'Diffusion' },
  tv: { code: 'TV', name: 'Traceability & Verification' },
  cc: { code: 'CC', name: 'Certification & Compliance' },
  li: { code: 'LI', name: 'Livelihood Improvement' },
  cm: { code: 'CM', name: 'Common' },
};

export const pillarColor = {
  Diffusion: '#2DD4BF',
  'Traceability & Verification': '#FB923C',
  'Certification & Compliance': '#60A5FA',
  'Livelihood Improvement': '#F472B6',
  Common: '#C084FC',
};

export const noAccessText = "You Don't Have Access";

export const researchDashboardMap = {
  'research/dashboard/diffusion': 'research_df',
  'research/dashboard/tv': 'research_tv',
  'research/dashboard/cc': 'research_cc',
  'research/dashboard/livelihood': 'research_li',
};

export const researchDataMap = {
  'research/diffusionData': 'research_df',
  'research/tvData': 'research_tv',
  'research/ccData': 'research_cc',
  'research/livelihoodData': 'research_li',
};

export const researchPermissionConfig = {
  data_collection: {
    key: 'dataKeys',
    map: researchDataMap,
  },
  dashboard: {
    key: 'dashboardKeys',
    map: researchDashboardMap,
  },
};

export const GAUGE_COLORS = [
  '#CDE5FF',
  '#A7F3D0',
  '#F9A8D4',
  '#FDE68A',
  '#A5B4FC',
  '#FCA5A5',
  '#DDD6FE',
  '#BBF7D0',
  '#BFDBFE',
  '#FECACA',
];
